import { getTenantLogoUrl } from '@/lib/tenantAssets'
import Image from 'next/image'

const FooterLogo = ({ tenantId }: { tenantId: string }) => {

  return (
    <div className="h-40 w-40 relative">
      <Image
        src={getTenantLogoUrl(tenantId, "light") || ""}
        alt={`Company Logo`}
        fill
        style={{ objectFit: "contain" }}
      />
    </div>
  )
}

export default FooterLogo